<template>
  <div id="app">
     <router-view :height="screen_height" :width="screen_width" />
  </div>
</template>

<script>
  export default {
    name: 'App',
    data: ()=>{
      return {
        screen_height: window.innerHeight,
        screen_width: window.innerWidth,
      }
    },
    created(){
      window.addEventListener("resize", this.window_resize);
    },
    destroyed() {
      window.removeEventListener("resize", this.window_resize);
    },
    methods: {
      window_resize: function(e){
        this.screen_height = window.innerHeight;
        if(window.innerWidth <= 800) this.screen_width = 800;
        else this.screen_width = window.innerWidth;
      }
    },
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue